define('default-ui',[], function() {

  var app = angular.module('default.ui', []);

  app.service('$defaultUI', [function() {
    return function() {
    	
    	alert('123');

    }; // End return
  }]); // End angular.service();
}); // End define();

